import { render, staticRenderFns } from "./ClientWelcomeView.vue?vue&type=template&id=74abeec5&scoped=true&"
import script from "./ClientWelcomeView.vue?vue&type=script&setup=true&lang=js&"
export * from "./ClientWelcomeView.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ClientWelcomeView.vue?vue&type=style&index=0&id=74abeec5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74abeec5",
  null
  
)

export default component.exports